import { ArrowBack, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemText, ListSubheader, Paper, Tooltip, Typography } from '@mui/material';
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { base_url } from '../../../../../utils/GlobalVariables';

const DetailAdendum = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const adendumState = location.state.adendum || null;
    const kontrakState = location.state.kontrak || null;

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Kembali</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate(-1)
                        }} color="error"><ArrowBack /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                <Paper variant='outlined'>
                    <List subheader={
                        <ListSubheader component="div" id="utility">
                            Informasi Adendum
                        </ListSubheader>
                    }
                    >
                        <ListItem alignItems="flex-start">
                            <Grid container>
                                <Grid item md={12}>
                                    <ListItemText
                                        primary="Pekerjaan"
                                        secondary={kontrakState.pekerjaan}
                                    />
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Divider />
                        <ListItem alignItems="flex-start">
                            <Grid container>
                                <Grid item md={6}>
                                    <ListItemText
                                        primary="Nomor Adendum"
                                        secondary={adendumState.no_adendum}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <ListItemText
                                        primary="Tanggal Adendum"
                                        secondary={adendumState.tgl_adendum}
                                    />
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Divider />
                        <ListItem alignItems="flex-start">
                            <Grid container>
                                <Grid item md={6}>
                                    <ListItemText
                                        primary="Jumlah Kontrak"
                                        secondary={"Rp. " + rP(kontrakState.jumlah_kontrak)}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <ListItemText
                                        primary="Jangka Waktu Pelaksanaan"
                                        secondary={adendumState.tgl_mulai + " s/d " + adendumState.tgl_selesai}
                                    />
                                </Grid>
                            </Grid>
                        </ListItem>
                    </List>
                </Paper>
                <Paper variant='outlined' sx={{ mt: 2 }}>
                    <Accordion>
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                            <Typography>File Adendum</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <iframe width='100%' height={700} title="Pdf" src={base_url + '/uploads/' + adendumState.tahun_anggaran + '/' + adendumState.id_opd + '/kontrak/adendum/' + adendumState.file} />
                        </AccordionDetails>
                    </Accordion>
                </Paper>
            </CardContent>
        </Card>
    )
}

export default DetailAdendum